<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <bnp-grid :key="tableKey" :hasRowNum="false" :propsColumn="Column" :propsRows="Row" :Selectable="false" :action="true">
          <template slot="amount" slot-scope="props">
            {{ $Comma3ragham(props.props.amount) }}
          </template>
          <template slot="description" slot-scope="props">
            <span> {{ props.props.description.length > 25 ? props.props.description.substring(0, 25) + '...' : props.props.description.substring(0, 25) }} </span>
          </template>
          <template slot="filePath" slot-scope="props">
            <a v-if="props.props.filepath != null && props.props != ''" target="new" :href="$cookies.get('URL') + props.props.filePath">
              <i class="fas fa-download"></i>
            </a>
          </template>
          <template slot="action-slot" slot-scope="props">
            <request-info :RequestRow="props.props" :ApiAction="'PaymentPermission'" @Success="GetData" @DataEdit="DataEdit" :IsRequest="false" :IsDelete="true" :IsEdit="true" :FormAutomation="ControlName"></request-info>
          </template>
        </bnp-grid>
      </div>
    </div>
  </div>
</template>
<script>
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import RequestInfo from '@/components/AutomAtion/RequestInfo.vue'
export default {
  components: { BnpGrid, RequestInfo },
  data() {
    return {
      Row: [],
      Column: [
        {
          name: 'namfam',
          label: 'درخواست کننده',
          visibility: true,
        },
        {
          name: 'tblComboGrp104Name',
          label: 'نوع درخواست',
          visibility: true,
        },
        {
          name: 'amount',
          label: 'مبلغ ',
          visibility: true,
        },
        {
          name: 'description',
          label: 'توضیحات ',
          visibility: true,
        },
        {
          name: 'filePath',
          label: 'پیوست',
          visibility: true,
        },
      ],
      tableKey: 0,
      ControlName:""
    }
  },
  methods: {
    GetData() {
      var dataAxios = { Action: 'PaymentPermission/?id=' + this.$session.get('UserInfo').tblUserId, Method: 'GET', Arryfieldvalue: null }
      this.$PostData(dataAxios).then((result) => {
        this.Row = result
        this.tableKey++
        // console.warn(result)
      })
    },
    DataEdit(data) {
      this.$emit('Edit', data)
    },
    GetFormAutomationId(){
      this.$FindTableNameOnAutomationCartabl(6).then((res) => {
             this.ControlName= res
            })
    }
  },
  created() {
    this.GetFormAutomationId()
    this.GetData()
  },
}
</script>
